module.exports = __webpack_public_path__ + "static/hohe-bonbon-dose_1.0c6868b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fulls/hohe-bonbon-dose_1.jpg
// module id = 550
// module chunks = 35783957827783